const content: { [key: string]: any } = {
  teamDetail: 'Team Detail',
};

export default content;
